var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"height":_vm.height,"width":_vm.width}},[_c('circle',{attrs:{"cx":_vm.width / 2,"cy":_vm.height / 2,"r":_vm.r,"fill":_vm.color}})])}
var staticRenderFns = []

export { render, staticRenderFns }